import React from 'react';
import { Divider } from 'antd';
import dayjs from 'dayjs';
import { MemoDeep } from '@/components';
import OrderStateComp from '@/components/order-state';
import cx from './index.module.scss';

const handleServiceDuration = (seconds?: number) => {
  if (!seconds) return '-';

  if (seconds < 60) {
    return seconds.toString().padStart(2, '0') + '秒';
  } else {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return minutes + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';
  }
};

const serviceTime = (timestamp: number) => {
  if (!timestamp) return '-';

  return dayjs(timestamp).format('YYYY/MM/DD HH:mm:ss');
};

interface MemberOrderItemProps {
  key: number;
  serviceOrderId: string;
  createTime: number;
  state: Service.OrderState;
  goodsName: string;
  amount: number;
  serviceDuration: number;
  handleViewInfo: () => void;
}

const MemberOrderInfoItem: React.FC<MemberOrderItemProps> = props => {
  const { state, goodsName, createTime, serviceDuration, key, amount, handleViewInfo } = props;

  return (
    <div className={cx('member-order-info-item')} key={key} onClick={handleViewInfo}>
      <div className={cx('header')}>
        <div className={cx('product-name')}>{goodsName}</div>
        <OrderStateComp state={state} />
      </div>
      <Divider className={cx('divider')} />
      <div className={cx('bottom')}>
        <div className={cx('service-info')}>服务时间：{serviceTime(createTime)}</div>
        <div className={cx('service-info')}>服务时长：{handleServiceDuration(serviceDuration)}</div>
        <div className={cx('service-info')}>消费金额：{amount === null ? '-' : amount + '元'}</div>
      </div>
    </div>
  );
};
export default MemoDeep(MemberOrderInfoItem);
